import React from "react";

import nth0 from "@/modules/nth0";

import "./index.scss";
import { IVirtualBalls } from "@/types/GlobalTypes";
import { assetImg } from "@/modules/moduleImporter";

export default class LottoVirtualBalls extends React.Component<IVirtualBalls> {
	render() {
		if (!this.props.lottoResult)
			return null;

		const activeGame = this.props.activeGame;
		const pcode = activeGame.pcode === "m37" ? "m31" : activeGame.pcode;
		const lottoResult = this.props.lottoResult;
		const numberSplit = lottoResult.number.split(",");

		const enableRotation = this.props.enableRotation;
		const betClosed = this.props.betClosed;

		//For games with reversed display order
		const numberCount = numberSplit.length;

		const reversedIndexGames = ["m30", "m31"];
		const isReversedIndex = reversedIndexGames.indexOf(pcode) >= 0;

		const rand = Math.random();

		return (
			<div className={"lotto-virtual-balls" +
				(this.props.showHugeStreaming ? " hugestreaming" : "") +
				(!enableRotation && betClosed ? " bet-closed" : "") +
				(" " + pcode)
			}>
				{
					numberSplit.map((num: string, idx) => (
						<div key={"lvb_" + idx}>
							{
								num !== "x" ? [
									<div key={"lvb_" + idx + "_0"}>
										{
											//5th to 1st Text
											isReversedIndex ?
											nth0(numberCount - 1 - idx) :
											nth0(idx)
										}
									</div>,
									assetImg("win_number_gif_" + pcode,
										num + ".gif?a=" + rand,
										"ohrss_" + pcode + "_" + idx)
									// The scan result
									// <img key={"lvb_" + idx + "_1"}
									// 	src={activeGame.win_number_gif[num]}
									// 	alt={num} />
								] : [
										<div key={"lvb_" + idx + "_0"} />,
										<div key={"lvb_" + idx + "_1"} />
								]
							}
						</div>
					))
				}
			</div>
		);
	}

}